export default {
  'vip':'VIP 申请',
  'vipHeadSubTitle': '请填写以下信息申请Beijing International High-tech Exop的VIP身份，该身份由Beijing International High-tech Exop的主办单位发出，可能但不确定可以帮助您申请中国签证',
  'company': '公司信息',
  'cName': '公司名称',
  'cPhone': '公司电话',
  'cAddress': '公司地址',
  'cEmail': '公司邮箱',
  'vipInfo': '个人信息',
  'vipInfoTip': '提交前请填写护照号码，随后点击护照照片对应的上传区域上传护照照片',
  'table': {
    'Passport_number': '护照号码',
    'Passport_photo': '护照首页',
    'Full_name': '全名（如护照名）',
    'Status': '状态',
    'head': '头像',
    'Sex': '称谓',
    'Download_invitation': '下载邀请函',
    'Download_invitation2': '下载VIP卡',
    'submit': '提交申请'
  },
  'vipSubTitle': '您可以在此下载VIP卡',
  'statusText': ['未申请', '审核中', '审核未通过', '审核通过'],
  'clickUpload': '点击上传',
  'photoTitle': '上传护照照片',
  'photoSubTitle': '请在此处上传您护照首页照片',
  'headTitle': '上传头像照片',
  'headSubTitle': '请在此处上传您的头像照片',
  'tip1': '上传图片格式只能为“jpg、png、bmp，gif”四种，大小需在30K-1Mb以内',
  'tip2': '您所上传的照片必须为彩色，并且是于六个月内拍摄',
  'tip3': '请您上传清晰、无遮挡的护照首页照片，否则主办单位将会要求您重新上传',
  'uploadText': '点击此处或将照片拖拽至此框内上传',
  'errMsg': '请输入护照号码',
  'errMsg1': '请输入正确的护照号码',
  'errMsg2': '请上传护照首页',
  'errMsg3': '请上传头像',
  'applyNow': '立刻申请',
  'applyLater': '稍后申请',
  'applyBodyText': '恭喜您预登记成功，经系统认定您符合申请VIP用户的资格',
  'downloadStart': '开始下载',
  'sex': '先生/女士',
  'cardNumberEmpty': '胸卡号为空'
}
